import { GridCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon';

export const BooleanCell: React.FC<React.PropsWithChildren<
  GridCellProps
>> = props => {
  const { dataItem, field } = props;
  return (
    <td>
      <StatusIcon type={field && dataItem[field] ? 'la-check' : 'la-times'} />
    </td>
  );
};

export const StatusIcon = styled(Icon)`
  &.la-check {
    color: var(--green-status-color);
  }

  &.la-times {
    color: var(--red-status-color);
  }
`;
